import { IFilter } from '../../types/filter';
import { TReduxActions } from '../../types/redux';
import { EFilterActionTypes } from '../../actions';
import { LOCATION } from '../../settings';

export const defaultFilterInitialState: IFilter = {
  deadlineVariants: [],
  locationVariants: [],
  deadline: undefined,
  minPrice: undefined,
  maxPrice: undefined,
  location: LOCATION.MOSCOW_AND_AREA.ID,
  rooms: [],
  minArea: undefined,
  maxArea: undefined,
  apartmentsWithDecoration: false,
  readyApartments: false,
};

export function filterReducer(state: IFilter = defaultFilterInitialState, action: TReduxActions) {
  switch (action.type) {
    case EFilterActionTypes.RegionChange:
      return { ...state, location: action.payload };
    case EFilterActionTypes.RoomsChange:
      return { ...state, rooms: action.payload };
    case EFilterActionTypes.MinPriceChange:
      return { ...state, minPrice: action.payload };
    case EFilterActionTypes.MaxPriceChange:
      return { ...state, maxPrice: action.payload };
    case EFilterActionTypes.MinAreaChange:
      return { ...state, minArea: action.payload };
    case EFilterActionTypes.MaxAreaChange:
      return { ...state, maxArea: action.payload };
    case EFilterActionTypes.DeadlineChange:
      return { ...state, deadline: action.payload };
    case EFilterActionTypes.DeadlineVariantsChange:
      return { ...state, deadlineVariants: action.payload };
    case EFilterActionTypes.ReadyApartmentChange:
      return { ...state, readyApartments: action.payload };
    case EFilterActionTypes.ApartmentWithDecorationChange:
      return { ...state, apartmentsWithDecoration: action.payload };

    default:
      return state;
  }
}
